import { render } from "./Nbus.vue?vue&type=template&id=c8306120&scoped=true"
import script from "./Nbus.vue?vue&type=script&lang=js"
export * from "./Nbus.vue?vue&type=script&lang=js"

import "./Nbus.vue?vue&type=style&index=0&id=c8306120&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8306120"]])

export default __exports__